// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"91":"6780bb81c31750f2","684":"5b3e5b8368ec69a4","747":"f3d5ff47c0994121","980":"5280dd087af2042b"}[chunkId] + ".css";
};